import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Auth } from 'aws-amplify';
import { useNotify, useTranslate, useAuthState, useRedirect } from 'react-admin';
import { LoaderApp } from "../../components/layout/LoaderApp";

// Layout
import { AuthLayout } from '../../layouts/AuthLayout';

import {
  CircularProgress,
  Typography,
  Button,
  TextField,
  Box,
  makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    color: '#2D4050',
    fontWeight: 'bold',
    marginBottom: 35,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
      marginBottom: 20,
    },
  },
  form: {
    width: '95%',
    maxWidth: 410,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '0 20px',
    },
  },
  textField: {
    padding: '2px 0px',
    fontSize: 17,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 35,
    },
  },
  button: {
    marginTop: 50,
    width: '100%',
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      marginTop: 30,
      height: 35,
    },
  },
  backButton: {
    marginTop: 10,
    width: '100%',
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      marginTop: 15,
      height: 35,
    },
  },
}));

export default function PasswordReset() {
  const classes = useStyles();
  const translate = useTranslate();
  const [btnSubmit, setBtnSubmit] = useState(true);
  const { register, handleSubmit, watch } = useForm();
  const notify = useNotify();
  const { authenticated, loaded } = useAuthState();
  const redirect = useRedirect();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePasswordReset = (data, event) => {
    event.preventDefault();
    setBtnSubmit('loading');
    window.localStorage.setItem('usernameForgotPass', data.email);
    Auth.forgotPassword(data.email)
      .then((data) => {
        notify('ra.notification.check_email_success', 'success');
        event.target.reset();
        setBtnSubmit(true);
        redirect("/change-password");
      })
      .catch((err) => {
        setBtnSubmit(true);
        notify('ra.notification.invalid_email_error', 'warning');
      });
    event.target.reset();
  };

  useEffect(() => loaded && authenticated && redirect('/'), [loaded]);

  return (
    <>
      {
        btnSubmit === "loading" && (
          <LoaderApp />
        )
      }
      <AuthLayout>
        <Typography variant="h5" className={classes.title}>
          {translate('ra.auth.title')}
        </Typography>
        <form onSubmit={handleSubmit(handlePasswordReset)} style={{ width: "100%" }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gridGap={theme.spacing(2)}
            width="100%"
            margin="0 auto"
            maxWidth={isMobile ? "90%" : "410px"}
          >
            <TextField
              fullWidth
              {...register('email', { required: true })}
              label={translate('ra.auth.emailField')}
              className={classes.textField}
              type="email"
              variant="outlined"
              required
            />

            <Button
              fullWidth
              type="submit"
              variant={btnSubmit === 'loading' ? 'outlined' : 'contained'}
              color="primary"
              size="large"
              className={classes.button}
              disabled={watch('email') === undefined || watch('email') === ''}
              style={{ width: '100%' }}
            >
              {btnSubmit === 'loading' ? (
                <CircularProgress color="primary" size="1.5rem" />
              ) : (
                translate('ra.action.resetPassword')
              )}
            </Button>

            <Link to="/login" style={{ textDecoration: 'none', width: '100%' }}>
              <Button
                fullWidth
                variant="outlined"
                color="inherit"
                size="large"
                className={classes.backButton}
                style={{ width: '100%' }}
              >
                {translate('ra.action.goBack')}
              </Button>
            </Link>
          </Box>
        </form>
      </AuthLayout>
    </>


  );
}
